import { Job } from "../../job/models/job.model";
import { BaseService } from "../../../../../core/services/base.service";
import { User, File } from "../model/user.model";

export class ProfileService {
  static async Get(): Promise<User> {
    return await BaseService.Get("/users/profile");
  }

  static async Patch(user: User): Promise<Job[]> {
    return await BaseService.Patch("/users/profile", {
      firstname: user.firstname,
      lastname: user.lastname,
      email: user.email,
      phoneNumber: user.phoneNumber,
      whatsappNotifiable: user.whatsappNotifiable,
      emailNotifiable: user.emailNotifiable,
    });
  }

  static async GetFile(userId: string, fileId: string): Promise<Blob> {
    return await BaseService.Blob('GET', `/users/${userId}/files/{fileId}?fileId=${fileId}`, undefined, undefined, false);
  }

  static async PatchFile(userId: string, file: globalThis.File): Promise<File> {
    const formData = new FormData();
    formData.append("file", file);
    return await BaseService.Patch(`/users/${userId}/files`, formData);
  }

  static async DeleteFile(userId: string, fileId: string): Promise<File> {
    return await BaseService.Delete(`/users/${userId}/files/${fileId}`);
  }
}
